import React from 'react';
import { Alert, Button, Container, Row } from 'react-bootstrap';

import styles from './AlertHighlighter.module.css';

export const AlertHighlighter = (props) => {
  const { variant = 'primary', children, onClose = () => {} } = props;

  const handleOnClose = async () => {
    onClose();
  };

  return (
    <Alert variant={variant}>
      <Container
        fluid={false}
        className="bg-transparent"
      >
        <Row className={styles.highlight}>
          {children}

          {props.onClose && (
            <Button
              variant="link"
              onClick={handleOnClose}
            >
              Cerrar
            </Button>
          )}
        </Row>
      </Container>
    </Alert>
  );
};
